import { SMSTermsAndConditions } from '@/components/SMSOptIn/SMSTermsAndConditions';

export function SMSOptInCheckboxLabel() {
  return (
    <span>
      I agree to receive occasional automated text offers from Asurion at my
      phone number and can opt-out anytime. Consent to receive texts is not
      required for purchase.&nbsp;
      <SMSTermsAndConditions>SMS terms</SMSTermsAndConditions>
    </span>
  );
}
